import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastComponent } from '@shared/components/toast/toast.component';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '@cargeny/environments/environment';
import { ModalSearchComponent } from '@shared/components/modal/modal-search/modal-search.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from '@shared/class/multi-translate-http-loader';
import { ENVIRONMENT } from '@shared/injection-token/environment';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { environmentConfigFactory } from '@shared/factories/environment-config.factory';
import { interceptorProviders } from '@shared/consts/interceptor-providers';
import { sentryProviders } from '@shared/consts/sentry-providers';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ModalSearchComponent,
    ToastComponent,
    TranslateModule.forRoot({
      useDefaultLang: false,
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient): MultiTranslateHttpLoader => {
          return new MultiTranslateHttpLoader(http);
        },
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    CookieService,
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    {
      provide: ENVIRONMENT_CONFIG,
      useFactory: () => environmentConfigFactory(environment),
    },
    provideHttpClient(withInterceptorsFromDi()),
    ...interceptorProviders,
    ...sentryProviders,
  ],
})
export class AppModule {}
